import { render, staticRenderFns } from "./RouteTabs.vue?vue&type=template&id=c5bf5d04&scoped=true&"
import script from "./RouteTabs.vue?vue&type=script&lang=js&"
export * from "./RouteTabs.vue?vue&type=script&lang=js&"
import style0 from "./RouteTabs.vue?vue&type=style&index=0&id=c5bf5d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bf5d04",
  null
  
)

/* custom blocks */
import block0 from "./RouteTabs.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports